import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {
    index: number;
    imageThumbnailUrl: string = "https://ipeceli.file.core.windows.net/pictures/logos/video_thumbnail.png?st=2019-12-20T19%3A03%3A24Z&se=2020-01-01T18%3A00%3A00Z&sp=r&sv=2018-03-28&sr=f&sig=vJTG40IUdBpZ3iZy%2FKPDl2KWgaNqDWEBO7dQauwGD7g%3D";
    mediaJSON = {
        "tiles": [
            {
                "title": "Tutorial 1",
                "description": "Getting Started",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-616620b4-f8cf-4471-a397-ea3d87028028/Tutorial%201_Getting_Started.mp4?sv=2017-04-17&sr=c&si=a0ae90ea-dce8-40a2-ad75-4815a4b11e31&sig=bf6npiMdRh%2FSkoii2fxeqKKk2NcdYX6Cjs2mj13NquI%3D&st=2019-12-20T20%3A23%3A37Z&se=2119-12-20T20%3A23%3A37Z",
            },
            {
                "title": "Tutorial 2",
                "description": "Assigning an ELI - Self Assessment",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-fdc9ff68-efe7-4388-a3f3-701966b72db0/Tutorial%202_%20Assigning_an_ELI_Self_Assessment.mp4?sv=2017-04-17&sr=c&si=7fcfcfad-ec0d-46ba-afbb-3324f430a8f8&sig=7u1m0AWZBaMWDZdCjp93mJgovHliAxgUYZ6jfGHpzW8%3D&st=2019-12-20T21%3A25%3A02Z&se=2119-12-20T21%3A25%3A02Z",
            },
            {
                "title": "Tutorial 3",
                "description": "Assigning an ELI 360 Assessment",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-7983ac4e-44ee-482c-91da-cca4671bfe29/Tutorial%203_%20Assigning_an_ELI_360_Assessment.mp4?sv=2017-04-17&sr=c&si=96c4cbb6-c646-40a6-8752-2510b5fa2f5f&sig=V5ak3XTaglNzdxi31ldjzaol2mYBodXIeOh2Kbmgo%2B8%3D&st=2019-12-20T21%3A29%3A41Z&se=2119-12-20T21%3A29%3A41Z",
            },
            {
                "title": "Tutorial 4",
                "description": "Managing and Completing ELI - Self Assessment from the Manage Clients Page",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-e74ec264-3a34-4647-832a-b37166e5deb2/Tutorial%204_%20Managing_and_Completing_ELI_Self_Assessment_from_the_Manage_Clients_Page.mp4?sv=2017-04-17&sr=c&si=da106c18-97ef-4915-ba8f-10fac61009e0&sig=QgY3QzSsMzxmRQGh3o8BuZCdpbx7FuyFgfBLBVsN7jg%3D&st=2019-12-20T21%3A33%3A33Z&se=2119-12-20T21%3A33%3A33Z",
            },
            {
                "title": "Tutorial 5",
                "description": "Managing and Completing ELI 360 Assessment from the Manage Clients Page",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-ce1e8796-be75-470c-b6f4-874c20e0211b/Tutorial%205_%20Managing_and_Completing_ELI_30_Assessment_from_the_Manage_Clients_Page.mp4?sv=2017-04-17&sr=c&si=f0eaf446-54cd-4299-96c9-83d005aa8b3f&sig=fjgogfg9o1iVYtSxOWd3lVrhj514hLrxuMR7W8zZfMQ%3D&st=2019-12-20T21%3A35%3A22Z&se=2119-12-20T21%3A35%3A22Z",
            },
            {
                "title": "Tutorial 6",
                "description": "Using the Manage Assessments Page",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-44434fb7-4e81-4f16-aee6-c575961cef48/Tutorial%206_%20Using_the_Manage_Assessments_Page.mp4?sv=2017-04-17&sr=c&si=8653c204-8cf7-4edc-be17-5f7ed424868a&sig=wTyYbIuKJEWPLq4bfDxoRBRLgqTutrKKnGl1zuFzUuM%3D&st=2019-12-20T21%3A36%3A38Z&se=2119-12-20T21%3A36%3A38Z",
            },
            {
                "title": "Tutorial 7",
                "description": "Customizing Email Templates",
                "imageUrl": this.imageThumbnailUrl,
                "videoUrl": "https://ipeceli.blob.core.windows.net/asset-8a002560-a89d-4ccd-8f2e-b916070ba29b/Tutorial%207_%20Customizing%20Email%20Templates.mp4?sv=2017-04-17&sr=c&si=48c04fca-e89b-4153-b24c-cc4e66cc5206&sig=d0QZq9qEidirRoeIoRaQmH0isVtWKHboAchpem8kS14%3D&st=2019-12-20T21%3A07%3A26Z&se=2119-12-20T21%3A07%3A26Z",
            },
        ]
    };
    currentVideoUrl: string;
    videoModalTitle: string;
    videoModalDescription: string;

    constructor(private activatedRoute: ActivatedRoute, private router: Router) {
        this.activatedRoute.params.subscribe(params => {
            console.log('params', params);
            this.index = parseInt(params['index']);
            this.createVideo(this.index);
        });
    }

    ngOnInit() {

    }
    createVideo(index: number) {

        this.videoModalTitle = this.mediaJSON.tiles[index].title;
        this.videoModalDescription = this.mediaJSON.tiles[index].description;

        //$('#video').get(0).play();
        //document.getElementById('video').play();
        setTimeout(() => {
            var video = $('<video />', {
                type: 'video/mp4',
                src: this.mediaJSON.tiles[index].videoUrl,
                controls: true,
                height: '100%',
                width: '100%',
                autoplay: true,
            });
            $('.video-container').html(video);
            setTimeout(() => {
                $('video').trigger('play');
            });
        }, 400);


    }

    closeVideoModal() {
        this.router.navigate(['/app/coach_home']);
    }

}
